export type JointVisibilityUiState = {
  focus: boolean;
  labelsOff: boolean;
  frameAxes: boolean;
  positionSlider: boolean;
};

export const JOINT_VISIBILITY_UI_EVENT = "selected-joint-visibility-options-changed";
export const JOINT_FRAME_AXES_NAME = "__selectedJointFrameAxes";

export const DEFAULT_JOINT_VISIBILITY_UI_STATE: JointVisibilityUiState = {
  focus: false,
  labelsOff: true,
  frameAxes: false,
  positionSlider: false,
};

let currentJointVisibilityUiState: JointVisibilityUiState = {
  ...DEFAULT_JOINT_VISIBILITY_UI_STATE,
};

export function getJointVisibilityUiState(): JointVisibilityUiState {
  return { ...currentJointVisibilityUiState };
}

export function setJointVisibilityUiState(
  patch: Partial<JointVisibilityUiState>
): JointVisibilityUiState {
  currentJointVisibilityUiState = {
    ...currentJointVisibilityUiState,
    ...patch,
  };
  dispatchJointVisibilityUiState(currentJointVisibilityUiState);
  return getJointVisibilityUiState();
}

export function dispatchJointVisibilityUiState(state: JointVisibilityUiState): void {
  currentJointVisibilityUiState = { ...state };
  if (typeof window === "undefined") return;
  window.dispatchEvent(
    new CustomEvent(JOINT_VISIBILITY_UI_EVENT, {
      detail: { ...state },
    })
  );
}
